document.addEventListener('DOMContentLoaded', function() {
  const sectionId = document.querySelector('.keyboard-fit-checker')?.id;
  if (!sectionId || !window.keyboardFitCheckerData || !window.keyboardFitCheckerKeyboards) return;

  const selectId = sectionId.replace('KeyboardFitChecker-', '');
  const input = document.getElementById(`keyboard-select-${selectId}`);
  const dropdown = document.getElementById(`keyboard-dropdown-${selectId}`);
  const resultWrapper = document.getElementById(`keyboard-result-wrapper-${selectId}`);
  const result = document.getElementById(`keyboard-result-${selectId}`);
  const resultRecommendations = document.getElementById(`keyboard-result-recommendations-${selectId}`);
  
  if (!input || !dropdown || !resultWrapper || !result || !resultRecommendations) return;

  const { trayDimensions, hasInnerLegClearance, innerLegDimensions } = window.keyboardFitCheckerData;
  const keyboards = window.keyboardFitCheckerKeyboards;

  const STATUS_PRIORITY = { fail: 4, uncertain: 3, close: 2, fit: 1 };

  function combineStatus(a, b) {
    return STATUS_PRIORITY[a] >= STATUS_PRIORITY[b] ? a : b;
  }

  function getWidthStatus(keyboardMm, trayMm) {
    if (keyboardMm <= trayMm) return 'fit';
    return 'fail';
  }

  function getHeightStatus(keyboardMm, trayMm) {
    if (keyboardMm <= trayMm) return 'fit';
    return 'uncertain';
  }

  function getDepthStatus(keyboardMm, trayMm) {
    if (keyboardMm <= trayMm) return 'fit';
    if (keyboardMm <= trayMm + 50) return 'close';
    return 'uncertain';
  }

  function evaluateClearanceZone(keyboardMm, zoneCm) {
    const trayWidthMm = zoneCm.width * 10;
    const trayDepthMm = zoneCm.depth * 10;
    const trayHeightMm = zoneCm.height * 10;

    return {
      widthStatus: getWidthStatus(keyboardMm.width, trayWidthMm),
      depthStatus: getDepthStatus(keyboardMm.depth, trayDepthMm),
      heightStatus: getHeightStatus(keyboardMm.height, trayHeightMm),
      trayWidthMm,
      trayDepthMm,
      trayHeightMm,
      trayWidthCm: zoneCm.width,
      trayDepthCm: zoneCm.depth,
      trayHeightCm: zoneCm.height
    };
  }

  function keyboardFitsClearance(keyboardCm, tray, innerLeg) {
    const fitsTray =
      keyboardCm.width <= tray.width &&
      keyboardCm.depth <= tray.depth &&
      keyboardCm.height <= tray.height;

    if (!innerLeg) {
      return fitsTray;
    }

    const fitsInnerLeg =
      keyboardCm.width <= innerLeg.width &&
      keyboardCm.depth <= innerLeg.depth &&
      keyboardCm.height <= innerLeg.height;

    return fitsTray || fitsInnerLeg;
  }

  function zoneFitsPerfectly(zone) {
    return zone.widthStatus === 'fit' && zone.depthStatus === 'fit' && zone.heightStatus === 'fit';
  }

  // "Doesn't fit as standard" states say so plainly, then give a way forward: a custom tray (call or chat) and,
  // below the result, the desks in Compare whose tray fits.
  const ASK_URL = (window.keyboardFitCheckerData && window.keyboardFitCheckerData.askUrl) || 'https://calendar.app.google/rUqWVZhQfZb2CPN49';
  const notStandard = function (what) {
    return '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--uncertain">'
      + '<strong class="keyboard-fit-checker__fit-headline">Doesn\'t fit this tray as standard.</strong> '
      + 'We can build it with a ' + what + ': <a href="' + ASK_URL + '" target="_blank" rel="noopener">book a call</a> or <a href="#chat" data-buso-chat>chat with us</a>.</div>';
  };
  const customDepthFitMessage = notStandard('deeper tray');
  const customHeightFitMessage = notStandard('taller tray opening');
  const customSizesFitMessage = notStandard('larger tray');

  function isOrangeDimensionStatus(status, dimension) {
    if (status === 'uncertain') return true;
    if (dimension === 'depth' && status === 'close') return true;
    return false;
  }

  function countOrangeDimensions(trayZone, innerZone) {
    let count = 0;
    const checkZone = (zone) => {
      if (isOrangeDimensionStatus(zone.widthStatus, 'width')) count++;
      if (isOrangeDimensionStatus(zone.depthStatus, 'depth')) count++;
      if (isOrangeDimensionStatus(zone.heightStatus, 'height')) count++;
    };
    checkZone(trayZone);
    if (innerZone) checkZone(innerZone);
    return count;
  }

  function hasOrangeDepthOnly(trayZone, innerZone) {
    const zones = innerZone ? [trayZone, innerZone] : [trayZone];
    let depthOrange = false;
    let otherOrange = false;
    zones.forEach((zone) => {
      if (isOrangeDimensionStatus(zone.depthStatus, 'depth')) depthOrange = true;
      if (isOrangeDimensionStatus(zone.widthStatus, 'width')) otherOrange = true;
      if (isOrangeDimensionStatus(zone.heightStatus, 'height')) otherOrange = true;
    });
    return depthOrange && !otherOrange;
  }

  function hasOrangeHeightOnly(trayZone, innerZone) {
    const zones = innerZone ? [trayZone, innerZone] : [trayZone];
    let heightOrange = false;
    let otherOrange = false;
    zones.forEach((zone) => {
      if (isOrangeDimensionStatus(zone.heightStatus, 'height')) heightOrange = true;
      if (isOrangeDimensionStatus(zone.widthStatus, 'width')) otherOrange = true;
      if (isOrangeDimensionStatus(zone.depthStatus, 'depth')) otherOrange = true;
    });
    return heightOrange && !otherOrange;
  }

  function getUncertainFitMessage(trayZone, innerZone) {
    if (countOrangeDimensions(trayZone, innerZone) >= 2) {
      return customSizesFitMessage;
    }
    if (hasOrangeDepthOnly(trayZone, innerZone)) {
      return customDepthFitMessage;
    }
    if (hasOrangeHeightOnly(trayZone, innerZone)) {
      return customHeightFitMessage;
    }
    return customSizesFitMessage;
  }
  let selectedKeyboard = null;
  let filteredKeyboards = [];

  // SVG icons
  const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>`;
  
  const xIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>`;
  
  const questionIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
  </svg>`;

  // Where "ask us" goes when a keyboard isn't in the list (the same call link as the checkout)
  const NO_MATCH_URL = (window.keyboardFitCheckerData && window.keyboardFitCheckerData.askUrl) || 'https://calendar.app.google/rUqWVZhQfZb2CPN49';

  function renderDropdown() {
    if (filteredKeyboards.length === 0) {
      const searchTerm = input.value.trim();
      if (searchTerm === '') {
        dropdown.innerHTML = '<div class="keyboard-fit-checker__dropdown-item">No keyboards found</div>';
        dropdown.classList.add('active');
        return;
      }
      // AI search disabled - show simple "no results" message
      // Not in our list: give a way forward instead of a dead end
      dropdown.innerHTML = `
        <div class="keyboard-fit-checker__dropdown-item keyboard-fit-checker__dropdown-item--none">
          <div class="keyboard-fit-checker__dropdown-item-name">We don't have that keyboard in our list yet.</div>
          <div class="keyboard-fit-checker__dropdown-item-hint">Send us its width and depth and we'll check it for you: <a href="${NO_MATCH_URL}" target="_blank" rel="noopener">ask us</a>.</div>
        </div>
      `;
      dropdown.classList.add('active');
      
      // AI search functionality commented out
      // // Show AI search option when no keyboards found
      // dropdown.innerHTML = `
      //   <div class="keyboard-fit-checker__dropdown-item">
      //     <div class="keyboard-fit-checker__dropdown-item-name">No keyboards found</div>
      //   </div>
      //   <div class="keyboard-fit-checker__dropdown-item keyboard-fit-checker__dropdown-item--ai" data-ai-search="true">
      //     <div class="keyboard-fit-checker__dropdown-item-name">
      //       <span>🔍 Search via AI for "${searchTerm}"</span>
      //       <span class="keyboard-fit-checker__ai-disclaimer">Results may vary</span>
      //     </div>
      //   </div>
      // `;
      // dropdown.classList.add('active');
      // 
      // // Add click handler for AI search
      // const aiItem = dropdown.querySelector('[data-ai-search="true"]');
      // if (aiItem) {
      //   aiItem.addEventListener('click', function() {
      //     searchKeyboardViaAI(searchTerm);
      //   });
      // }
      return;
    }

    dropdown.innerHTML = filteredKeyboards.map((keyboard, index) => {
      const isSelected = selectedKeyboard && selectedKeyboard.name === keyboard.name;
      return `
        <div class="keyboard-fit-checker__dropdown-item ${isSelected ? 'selected' : ''}" 
             data-index="${index}">
          <div class="keyboard-fit-checker__dropdown-item-name">${keyboard.name}</div>
        </div>
      `;
    }).join('');

    dropdown.classList.add('active');

    // Add click handlers
    dropdown.querySelectorAll('.keyboard-fit-checker__dropdown-item').forEach(item => {
      item.addEventListener('click', function() {
        const index = parseInt(this.dataset.index);
        selectKeyboard(filteredKeyboards[index]);
      });
    });
  }

  function selectKeyboard(keyboard) {
    selectedKeyboard = keyboard;
    input.value = keyboard.name;
    dropdown.classList.remove('active');
    checkFit(keyboard);
  }

  // AI search functionality commented out
  // async function searchKeyboardViaAI(keyboardModel) {
  //   // Show loading state
  //   dropdown.innerHTML = '<div class="keyboard-fit-checker__dropdown-item"><div class="keyboard-fit-checker__dropdown-item-name">🔍 Searching via AI...</div></div>';
  //   dropdown.classList.add('active');
  //   input.disabled = true;
  //
  //   try {
  //     // Get edge function URL from section settings or use default Netlify deployment
  //     const edgeFunctionUrl = window.keyboardFitCheckerData?.edgeFunctionUrl || 
  //                             'https://busoaisearchkeyboard.netlify.app/.netlify/functions/keyboard-search';
  //     
  //     const response = await fetch(edgeFunctionUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ model: keyboardModel })
  //     });
  //
  //     if (!response.ok) {
  //       throw new Error('AI search service unavailable. Please try a different keyboard name or contact support.');
  //     }
  //
  //     const data = await response.json();
  //     
  //     // Edge function returns direct dimensions object
  //     if (data.error) {
  //       throw new Error(data.error);
  //     }
  //     
  //     if (!data.width || !data.depth || !data.height) {
  //       throw new Error('Incomplete dimensions returned from AI search.');
  //     }
  //     
  //     const dimensions = data;
  //
  //     // Create a keyboard object from AI response
  //     const aiKeyboard = {
  //       name: keyboardModel,
  //       width: dimensions.width * 10, // Convert cm to mm
  //       depth: dimensions.depth * 10,
  //       height: dimensions.height * 10,
  //       weight: dimensions.weight || 0,
  //       source: dimensions.source || 'AI Search',
  //       isAIResult: true
  //     };
  //
  //     // Select and check fit
  //     selectKeyboard(aiKeyboard);
  //     
  //     // Show disclaimer in result details
  //     setTimeout(() => {
  //       const resultDetailsEl = result.querySelector('.keyboard-fit-checker__result-details');
  //       if (resultDetailsEl) {
  //         const disclaimer = document.createElement('div');
  //         disclaimer.className = 'keyboard-fit-checker__ai-disclaimer-box';
  //         disclaimer.innerHTML = `
  //           <p><strong>⚠️ Results may vary:</strong> These dimensions were found via AI search and may not be 100% accurate. Please verify with the manufacturer's specifications.</p>
  //           ${dimensions.source ? `<p class="keyboard-fit-checker__ai-source">Source: ${dimensions.source}</p>` : ''}
  //         `;
  //         resultDetailsEl.insertBefore(disclaimer, resultDetailsEl.firstChild);
  //       }
  //     }, 100);
  //
  //   } catch (error) {
  //     // Show error in dropdown
  //     dropdown.innerHTML = `
  //       <div class="keyboard-fit-checker__dropdown-item keyboard-fit-checker__dropdown-item--error">
  //         <div class="keyboard-fit-checker__dropdown-item-name">
  //           ${error.message || 'AI search unavailable. Please contact support or try a different search term.'}
  //         </div>
  //       </div>
  //     `;
  //     console.error('AI search error:', error);
  //   } finally {
  //     input.disabled = false;
  //   }
  // }

  function checkFit(keyboard) {
    // Check if keyboard dimensions are valid
    const hasValidDimensions = keyboard.width > 0 && keyboard.depth > 0 && keyboard.height > 0 &&
                               !isNaN(keyboard.width) && !isNaN(keyboard.depth) && !isNaN(keyboard.height);
    
    // Tray dimensions are stored in cm, keyboard dimensions are in mm
    // Convert keyboard dimensions from mm to cm for comparison
    const keyboardWidthCm = keyboard.width / 10;
    const keyboardDepthCm = keyboard.depth / 10;
    const keyboardHeightCm = keyboard.height / 10;

    // Convert to mm for 5mm tolerance check
    const keyboardWidthMm = keyboard.width;
    const keyboardDepthMm = keyboard.depth;
    const keyboardHeightMm = keyboard.height;
    const keyboardMm = { width: keyboardWidthMm, depth: keyboardDepthMm, height: keyboardHeightMm };

    const trayZone = evaluateClearanceZone(keyboardMm, trayDimensions);
    const innerZone = hasInnerLegClearance && innerLegDimensions
      ? evaluateClearanceZone(keyboardMm, innerLegDimensions)
      : null;

    const widthStatus = innerZone
      ? combineStatus(trayZone.widthStatus, innerZone.widthStatus)
      : trayZone.widthStatus;
    const depthStatus = innerZone
      ? combineStatus(trayZone.depthStatus, innerZone.depthStatus)
      : trayZone.depthStatus;
    const heightStatus = innerZone
      ? combineStatus(trayZone.heightStatus, innerZone.heightStatus)
      : trayZone.heightStatus;

    const trayWidthMm = trayZone.trayWidthMm;
    const trayDepthMm = trayZone.trayDepthMm;
    const trayHeightMm = trayZone.trayHeightMm;

    const innerLegDesk = !!innerZone;
    const trayPerfect = zoneFitsPerfectly(trayZone);
    const innerPerfect = innerZone ? zoneFitsPerfectly(innerZone) : false;
    const eitherZonePerfect = innerLegDesk ? (trayPerfect || innerPerfect) : trayPerfect;

    const widthFailsInnerOnly = innerZone &&
      innerZone.widthStatus === 'fail' &&
      trayZone.widthStatus === 'fit';
    const allFit = innerLegDesk
      ? eitherZonePerfect
      : widthStatus === 'fit' && depthStatus === 'fit' && heightStatus === 'fit';
    const hasFail = innerLegDesk
      ? !eitherZonePerfect && trayZone.widthStatus === 'fail' && innerZone.widthStatus === 'fail'
      : widthStatus === 'fail';

    const resultTitle = document.getElementById(`keyboard-result-title-${selectId}`);
    const resultDetails = result.querySelector('.keyboard-fit-checker__result-details');
    const resultIcon = result.querySelector('.keyboard-fit-checker__result-icon');
    
    if (!resultTitle) {
      // Fallback if title element doesn't exist
      console.warn('Result title element not found');
    }

    // Calculate differences for uncertain state checks
    const widthDifferenceMm = keyboardWidthMm - trayWidthMm;
    const depthDifferenceMm = keyboardDepthMm - trayDepthMm;
    const heightDifferenceMm = keyboardHeightMm - trayHeightMm;

    // Check for uncertain state conditions (for messaging)
    // Height is uncertain if it's too large (never fails)
    const isHeightTooLarge = heightStatus === 'uncertain' && widthStatus === 'fit' && (depthStatus === 'fit' || depthStatus === 'close');
    // Depth is uncertain if it doesn't fit (>5cm hangover)
    const isDepthUncertain = depthStatus === 'uncertain' && widthStatus === 'fit';

    // Priority-based decision logic:
    // 1. WIDTH is most important - if width fails, always show red X
    // 2. DEPTH is second priority
    // 3. HEIGHT is third/least important
    
    // Determine result state: question mark for uncertain cases, red/x if fail, green/tick otherwise
    let resultState = 'fit';
    let resultIconHtml = checkIcon;
    let isUncertain = false;
    
    if (!hasValidDimensions) {
      resultState = 'uncertain';
      resultIconHtml = questionIcon;
      isUncertain = true;
    } else if (innerLegDesk && eitherZonePerfect) {
      resultState = 'fit';
      resultIconHtml = checkIcon;
    } else if (innerLegDesk) {
      resultState = 'uncertain';
      resultIconHtml = questionIcon;
      isUncertain = true;
    } else if (widthStatus === 'fail') {
      resultState = 'no-fit';
      resultIconHtml = xIcon;
    } else if (depthStatus === 'uncertain') {
      resultState = 'uncertain';
      resultIconHtml = questionIcon;
      isUncertain = true;
    } else if (heightStatus === 'uncertain') {
      resultState = 'uncertain';
      resultIconHtml = questionIcon;
      isUncertain = true;
    } else {
      resultState = 'fit';
      resultIconHtml = checkIcon;
    }
    
    result.className = `keyboard-fit-checker__result ${resultState}`;
    resultIcon.innerHTML = resultIconHtml;
    
    // Format dimensions for display
    const keyboardWidthDisplay = keyboardWidthCm.toFixed(1);
    const keyboardDepthDisplay = keyboardDepthCm.toFixed(1);
    const keyboardHeightDisplay = keyboardHeightCm.toFixed(1);
    const trayWidthDisplay = trayZone.trayWidthCm.toFixed(1);
    const trayDepthDisplay = trayZone.trayDepthCm.toFixed(1);
    const trayHeightDisplay = trayZone.trayHeightCm.toFixed(1);

    // Get status class for each dimension
    function getStatusClass(status, isHeight = false, isDepth = false) {
      if (status === 'fit') return 'pass';
      if (status === 'close') return 'close';
      if (status === 'uncertain') return 'uncertain'; // Height and depth can be uncertain (orange/yellow)
      // Height and depth should never show red - always show uncertain if not fit
      if ((isHeight || isDepth) && status === 'fail') return 'uncertain';
      return 'fail';
    }

    // Determine overall fit message (respecting priority: width > depth > height)
    const hasClose = depthStatus === 'close'; // Only depth can be close (slight hangover)
    
    let fitMessage = '';
    let customSizeMessage = '';
    // "Fits" with the real margin when it is tight: 1 mm to spare should not read as "fits perfectly".
    // The zone it fits in is the tray, or the space between the inner legs on desks that have it.
    function successMessage() {
      const zone = zoneFitsPerfectly(trayZone) ? trayZone : (innerZone && zoneFitsPerfectly(innerZone) ? innerZone : trayZone);
      const spareMm = Math.round(zone.trayWidthMm - keyboardMm.width);
      const text = spareMm >= 0 && spareMm < 10
        ? `Your keyboard fits, with ${spareMm} mm to spare across the width. Check your keyboard's measurements to be sure.`
        : 'Your keyboard fits.';
      return '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--success">' + text + '</div>';
    }
    
    if (!hasValidDimensions) {
      fitMessage = '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--uncertain">Unable to determine fit.</div>';
      customSizeMessage = '<div class="keyboard-fit-checker__custom-size-message">For custom sizes, <a href="' + ASK_URL + '" target="_blank" rel="noopener">book a call</a> or <a href="#chat" data-buso-chat>chat with us</a>.</div>';
    } else if (innerLegDesk && eitherZonePerfect) {
      fitMessage = successMessage();
    } else if (innerLegDesk) {
      fitMessage = getUncertainFitMessage(trayZone, innerZone);
    } else if (widthStatus === 'fail') {
      if (widthFailsInnerOnly) {
        fitMessage = '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--fail">Your keyboard is too wide for the space between the desk\'s inner legs.</div>';
      } else {
        fitMessage = '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--fail"><strong class="keyboard-fit-checker__fit-headline">Your keyboard doesn\'t fit this desk.</strong> See the desks below, or <a href="' + ASK_URL + '" target="_blank" rel="noopener">book a call</a> or <a href="#chat" data-buso-chat>chat with us</a> about a custom size.</div>';
      }
    } else if (allFit) {
      // All dimensions fit perfectly - show success message
      fitMessage = successMessage();
    } else if (isUncertain) {
      fitMessage = getUncertainFitMessage(trayZone, innerZone);
      // Don't show redundant customSizeMessage when uncertain messages already mention contacting support
    } else if (allFit) {
      fitMessage = successMessage();
    } else if (hasClose && widthStatus === 'fit' && heightStatus === 'fit') {
      // PRIORITY 2: Depth has slight hangover (width and height fit)
      fitMessage = '<div class="keyboard-fit-checker__fit-message keyboard-fit-checker__fit-message--close">Your keyboard fits, but may hang over the edge slightly.</div>';
    }

    // Set the title outside the colored box (will be placed above the result box)
    if (resultTitle) {
      resultTitle.innerHTML = `
        <div class="keyboard-fit-checker__name-row">
          <span class="keyboard-fit-checker__keyboard-name">${keyboard.name}</span>
          <span class="keyboard-fit-checker__separator">></span>
          <span class="keyboard-fit-checker__product-name">${window.keyboardFitCheckerData.productName}</span>
        </div>
      `;
    }
    
    // Find recommended products if keyboard doesn't fit
    let recommendationsHtml = '';
    
    // Weight: both rail options are rated for 100 kg+, so heavy keyboards get reassurance, not an upsell
    const keyboardWeight = parseFloat(keyboard.weight) || 0;
    if (keyboardWeight > 20 && !isNaN(keyboardWeight)) {
      recommendationsHtml += `
        <div class="keyboard-fit-checker__weight-recommendation">
          <p class="keyboard-fit-checker__weight-warning">
            At ${Math.round(keyboardWeight)} kg, your keyboard is well within the keyboard rails' 100 kg+ rating.
          </p>
        </div>
      `;
    }
    
    // Desks that fit: after a fail, and also when it only fits with a custom tray
    if ((hasFail || isUncertain) && window.keyboardFitCheckerData.compareProducts) {
      // First, find exact fits (all dimensions fit perfectly)
      const exactFitProducts = window.keyboardFitCheckerData.compareProducts.filter(product => {
        if (!product.trayDimensions || product.id === window.keyboardFitCheckerData.currentProductId) {
          return false;
        }
        return keyboardFitsClearance(
          { width: keyboardWidthCm, depth: keyboardDepthCm, height: keyboardHeightCm },
          product.trayDimensions,
          product.hasInnerLegClearance ? product.innerLegDimensions : null
        );
      });

      // If no exact fits, also check for "may hang over" options (width and height fit, depth within 10cm)
      let recommendedProducts = exactFitProducts;
      if (exactFitProducts.length === 0) {
        const hangOverProducts = window.keyboardFitCheckerData.compareProducts.filter(product => {
          if (!product.trayDimensions || product.id === window.keyboardFitCheckerData.currentProductId) {
            return false;
          }
          const productWidthCm = product.trayDimensions.width;
          const productDepthCm = product.trayDimensions.depth;
          const productHeightCm = product.trayDimensions.height;
          const productDepthMm = productDepthCm * 10;
          const innerLeg = product.hasInnerLegClearance ? product.innerLegDimensions : null;
          const maxWidthCm = innerLeg ? Math.min(productWidthCm, innerLeg.width) : productWidthCm;
          const maxHeightCm = innerLeg ? Math.min(productHeightCm, innerLeg.height) : productHeightCm;

          return keyboardWidthCm <= maxWidthCm &&
                 keyboardHeightCm <= maxHeightCm &&
                 keyboardDepthMm > productDepthMm &&
                 keyboardDepthMm <= productDepthMm + 100;
        });
        recommendedProducts = hangOverProducts;
      }

      // Limit to 3 recommendations (max 3 on desktop, max 2 on mobile via CSS)
      recommendedProducts = recommendedProducts.slice(0, 3);

      if (recommendedProducts.length > 0) {
        recommendationsHtml += `
          <h4 class="keyboard-fit-checker__recommendations-title">Desks with a tray that fits your keyboard</h4>
          <div class="keyboard-fit-checker__recommendations-grid">
            ${recommendedProducts.map(product => `
              <a href="${product.url}" class="keyboard-fit-checker__recommendation-card">
                <div class="keyboard-fit-checker__recommendation-image-wrapper">
                  ${product.image ? `<img src="${product.image}" alt="${product.title}" class="keyboard-fit-checker__recommendation-image">` : ''}
                </div>
                <div class="keyboard-fit-checker__recommendation-info">
                  <div class="keyboard-fit-checker__recommendation-title">${product.title}</div>
                </div>
              </a>
            `).join('')}
          </div>
        `;
      }
    }

    function buildDimensionRow(label, keyboardVal, zoneStatus, trayVal, isHeight, isDepth) {
      const op = zoneStatus === 'fit' ? '≤' : '>';
      const depthWarning = zoneStatus === 'close'
        ? ' <span class="keyboard-fit-checker__depth-warning">(may hang over slightly)</span>'
        : '';
      return `
        <div class="keyboard-fit-checker__dimension-row">
          <span class="keyboard-fit-checker__dimension-label">${label}:</span>
          <span class="keyboard-fit-checker__dimension-comparison ${getStatusClass(zoneStatus, isHeight, isDepth)}">${keyboardVal} cm ${op} ${trayVal} cm${isDepth ? depthWarning : ''}</span>
        </div>
      `;
    }

    function buildZoneDimensionRows(zone) {
      return `
        ${buildDimensionRow('Width', keyboardWidthDisplay, zone.widthStatus, zone.trayWidthCm.toFixed(1), false, false)}
        ${buildDimensionRow('Depth', keyboardDepthDisplay, zone.depthStatus, zone.trayDepthCm.toFixed(1), false, true)}
        ${buildDimensionRow('Height', keyboardHeightDisplay, zone.heightStatus, zone.trayHeightCm.toFixed(1), true, false)}
      `;
    }

    const dimensionComparison = hasValidDimensions ? `
      <div class="keyboard-fit-checker__comparison">
        ${buildZoneDimensionRows(trayZone)}
        ${innerZone ? `
          <p class="keyboard-fit-checker__inner-leg-results-heading">Space between inner legs</p>
          ${buildZoneDimensionRows(innerZone)}
        ` : ''}
      </div>
    ` : '';

    resultDetails.innerHTML = `
      ${fitMessage}
      ${customSizeMessage}
      ${dimensionComparison}
    `;

    if (recommendationsHtml) {
      resultRecommendations.innerHTML = `<div class="keyboard-fit-checker__recommendations">${recommendationsHtml}</div>`;
    } else {
      resultRecommendations.innerHTML = '';
    }

    resultWrapper.style.display = 'flex';
  }

  // Search functionality - search anywhere in the keyboard name
  input.addEventListener('input', function(e) {
    const searchTerm = e.target.value.toLowerCase().trim();
    
    if (searchTerm === '') {
      filteredKeyboards = [];
      selectedKeyboard = null;
      resultWrapper.style.display = 'none';
      dropdown.classList.remove('active');
    } else {
      // Filter keyboards that contain the search term anywhere in the name (case-insensitive)
      filteredKeyboards = keyboards.filter(keyboard => 
        keyboard.name.toLowerCase().includes(searchTerm)
      );
      renderDropdown();
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!input.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.classList.remove('active');
    }
  });

  // Don't show dropdown on focus if input is empty
  input.addEventListener('focus', function() {
    if (input.value.trim() !== '') {
      const searchTerm = input.value.toLowerCase().trim();
      filteredKeyboards = keyboards.filter(keyboard => 
        keyboard.name.toLowerCase().includes(searchTerm)
      );
      renderDropdown();
    }
  });
});
